import { render, staticRenderFns } from "./ProgramSummaryCardLayout.vue?vue&type=template&id=70b7f033&scoped=true"
import script from "./ProgramSummaryCardLayout.vue?vue&type=script&lang=js"
export * from "./ProgramSummaryCardLayout.vue?vue&type=script&lang=js"
import style0 from "./ProgramSummaryCardLayout.vue?vue&type=style&index=0&id=70b7f033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7f033",
  null
  
)

export default component.exports